import { createRouter, createWebHashHistory } from 'vue-router'

const { isLogin } = localStorage

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/HomePage')
  },
  {
    path: '/cart',
    name: 'CartPage',
    component: () => import(/* webpackChunkName: "cart" */ '@/views/cart/CartPage')
  },
  {
    path: '/order',
    name: 'OrderPage',
    component: () => import(/* webpackChunkName: "order" */ '@/views/order/OrderPage')
  },
  {
    path: '/my',
    name: 'MyPage',
    component: () => import(/* webpackChunkName: "my" */ '@/views/my/MyPage')
  },
  {
    path: '/address',
    name: 'AddressPage',
    component: () => import(/* webpackChunkName: "address" */ '@/views/address/AddressPage')
  },
  {
    path: '/newAddress',
    name: 'NewAddressPage',
    component: () => import(/* webpackChunkName: "newAddress" */ '@/views/address/NewAddressPage')
  },
  {
    path: '/modifyAddress/:id',
    name: 'ModifyAddress',
    component: () => import(/* webpackChunkName: "newAddress" */ '@/views/address/ModifyAddressPage')
  },
  {
    path: '/pay/:id',
    name: 'PayPage',
    component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/PayPage')
  },
  {
    path: '/shop/:id',
    name: 'ShopPage',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/shop/ShopPage')
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () => import(/* webpackChunkName: "register" */ '@/views/register/RegisterPage'),
    beforeEnter (to, from, next) {
      isLogin ? next({ nema: 'HomePage' }) : next()
    }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/LoginPage'),
    beforeEnter (to, from, next) {
      isLogin ? next({ naem: 'HomePage' }) : next()
    }
  }
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (!isLogin && (to.name !== 'LoginPage' && to.name !== 'RegisterPage')) {
    next({ name: 'LoginPage' })
  } else {
    next()
  }
})

export default router
